import LoadingScreen from "../../LoadingScreen";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBoards } from "../../../Services/boardsService";
import Navbar from "../../Navbar";
import { Container, Wrapper, Board, AddBoard } from "./Styled";
import CreateBoard from "../../Modals/CreateBoardModal/CreateBoard";
import { useHistory } from "react-router";
import "../BoardsPage/Style.css";

const Boards = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pending, boardsData } = useSelector((state) => state.boards);
  const [openModal, setOpenModal] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [showTrialEnded, setShowTrialEnded] = useState(false);
  const [trialRemaining, setTrialRemaining] = useState(null);
  const [userName, setUserName] = useState("");
  const [isTrialExpired, setIsTrialExpired] = useState(false);

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleClick = (e) => {
    history.push(`/board/${e.target.id}`);
  };

  useEffect(() => {
    getBoards(false, dispatch);
  }, [dispatch]);

  useEffect(() => {
    document.title = "Boards | Trello Clone";
  }, []);

  useEffect(() => {
    const signupTime = localStorage.getItem("signupTime");
    const plan = localStorage.getItem("currentPlan");

    if (!signupTime) return;

    const interval = setInterval(() => {
      const signupDate = new Date(signupTime);
      const now = new Date();
      const diffMs = 3 * 24 * 60 * 60 * 1000 - (now - signupDate);

      if (diffMs <= 0) {
        if (!plan || plan === "none") {
          clearInterval(interval);
          setIsTrialExpired(true);
          history.push("/profile");
        } else {
          setTrialRemaining("");
          setIsTrialExpired(false);
        }
      } else {
        setIsTrialExpired(false);
        const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        setTrialRemaining(`${days} days, ${hours} hours, ${minutes} minutes`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(
          "https://project-manager-backend-afgb.onrender.com/user/profile",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await res.json();
        setUserName(data.name);
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <>
      {pending && <LoadingScreen />}
      <Container>
        <div className="overlay">
          <Navbar
            searchString={searchString}
            setSearchString={setSearchString}
          />

          <div className="welcm-back">
            <div className="welcome-text">
              <h1>Welcome Back{userName ? `, ${userName}` : ""}!</h1>
              <h5>
                Hope you're having a productive day. Let's get things done! 🚀
              </h5>
              <button
                onClick={() => {
                  document
                    .querySelector(".board-wrapper")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Check now
              </button>
            </div>
            <img
              src="https://cdn3d.iconscout.com/3d/premium/thumb/task-management-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--analytics-logo-calendar-business-meeting-startup-pack-people-illustrations-4000980.png?f=webp"
              alt=""
            />
          </div>

          {showTrialEnded && (
            <div className="free-trail">
              <h1>
                👋 The free trial of Premium has ended for Yentra Workspace.
              </h1>
            </div>
          )}
          {trialRemaining && (
            <div className="free-trail">
              <h1>🎉 Your free trial will end in {trialRemaining}</h1>
            </div>
          )}

          <Wrapper className="board-wrapper">
            {!pending &&
              boardsData.length > 0 &&
              boardsData
                .filter((item) =>
                  searchString
                    ? item.title
                        .toLowerCase()
                        .includes(searchString.toLowerCase())
                    : true
                )
                .map((item) => (
                  <Board
                    key={item._id}
                    link={item.backgroundImageLink}
                    isImage={item.isImage}
                    id={item._id}
                    onClick={(e) => handleClick(e)}
                  >
                    <h6 className="title-text">{item.title}</h6>
                  </Board>
                ))}

            {!pending && (
              <AddBoard
                onClick={() => {
                  if (isTrialExpired) {
                    alert(
                      "🚫 Your trial has ended. Please upgrade to create a new board."
                    );
                    return;
                  }
                  setOpenModal(true);
                }}
                style={{
                  cursor: isTrialExpired ? "not-allowed" : "pointer",
                  opacity: isTrialExpired ? 0.5 : 1,
                }}
              >
                Create new board
              </AddBoard>
            )}
            {openModal && <CreateBoard callback={handleModalClose} />}
          </Wrapper>
        </div>
      </Container>
    </>
  );
};

export default Boards;
